import { bool } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateEditorSettings, usePresetFieldNames, ValueCell } from "@tools";

export const ProfitabilityCell = observer((cellProps) => {
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  
  return (
    <ValueCell
      size="medium"
      isHeader
      style={{ cursor: allowEdition && "grab" }}
      { ...cellProps }
    >
      <span>
        {getFieldName("pt-profitability")}
      </span>
    </ValueCell>
  )
})

ProfitabilityCell.propTypes = {
  extendPadding: bool,
}